import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ComponentsModule } from '@app/components/components.module';
import { ContentModule } from '@app/components/content/content.module';
import { HeaderModule } from '@app/components/header/header.module';
import { TitleSectionModule } from '@app/components/title-section/title-section.module';
import { MomoManageVacationsModule } from '@app/momo/manage-vacations/manage-vacations.module';
import { MotManageVacationsModule } from '@app/mot/manage-vacations/manage-vacations.module';
import { PagesAnalytics } from '@app/services/analytics/models/analytics.enum';
import { PermissionsGuardService } from '@app/services/guard/permissions.guard.service';
import { PAGES } from '@app/shared/enums/pages/pages.enum';
import { getUrlFromMap } from '@app/shared/enums/pages/pages.urls';
import { TranslateModule } from '@ngx-translate/core';

import { MANAGE_VACATIONS_PERMISSIONS } from './manage-vacations.constants';
import { BaseManageVacationsPage } from './manage-vacations.page';

const routes: Routes = [
  {
    path: '',
    component: BaseManageVacationsPage
  },
  {
    path: 'edit',
    loadChildren: () =>
      import('./edit-vacations-proposals/edit-vacations-proposals.module').then((m) => m.EditVacationsProposalsModule),
    canActivate: [PermissionsGuardService],
    data: {
      allowGoBack: true,
      pagePermissions: MANAGE_VACATIONS_PERMISSIONS,
      pageToRedirectAfterLogin: getUrlFromMap(PAGES.VACATIONS_REQUEST),
      redirectTo: PAGES.HOME,
      pageAnalytics: PagesAnalytics.MANAGE_VACATIONS
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild(),
    ComponentsModule,
    HeaderModule,
    TitleSectionModule,
    ContentModule,
    MotManageVacationsModule,
    MomoManageVacationsModule
  ],
  declarations: [BaseManageVacationsPage]
})
export class ManageVacationsModule {}
